import React from 'react';
import { formatCurrency } from '../utils/formatter';
import { FY26_WATERFALL_DATA } from '../utils/FY26StaticData';

function RevenueWaterfall({ waterfallData }) {
  // Use provided waterfallData or fall back to default
  const data = waterfallData || FY26_WATERFALL_DATA;

  if (!data || data.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="text-center text-gray-500">Loading waterfall data...</div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="mb-6">
        <h3 className="text-lg font-semibold mb-2">FY26 Revenue Waterfall Forecast</h3>
        <p className="text-sm text-gray-500">Dynamic forecast waterfall: November 2025 – December 2026 (adjusts with metrics)</p>
      </div>

      {/* Editable Waterfall Table */}
      <div className="overflow-x-auto">
        <table className="text-xs border-collapse" style={{ tableLayout: 'fixed' }}>
          <thead>
            <tr className="bg-gray-100 sticky top-0">
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold" style={{ width: '100px' }}>Month</th>
              <th className="border border-gray-300 px-2 py-2 text-center font-semibold" style={{ width: '64px' }}>SQLs</th>
              <th className="border border-gray-300 px-2 py-2 text-center font-semibold" style={{ width: '64px' }}>SQOs</th>
              <th className="border border-gray-300 px-2 py-2 text-center font-semibold" style={{ width: '80px' }}>Closed Won</th>
              <th className="border border-gray-300 px-2 py-2 text-center font-semibold" style={{ width: '112px' }}>Monthly ARR</th>
              <th className="border border-gray-300 px-2 py-2 text-center font-semibold" style={{ width: '112px' }}>Cumulative ARR</th>
              <th className="border border-gray-300 px-2 py-2 text-center font-semibold" style={{ width: '80px' }}>Pipeline @ 3.5x</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr
                key={index}
                className={
                  row.isTotal
                    ? 'bg-blue-100 font-bold border-t-2 border-t-blue-400'
                    : (index % 2 === 0 ? 'bg-white' : 'bg-gray-50')
                }
              >
                <td className={`border border-gray-300 px-2 py-2 font-medium ${row.isTotal ? 'text-blue-900' : 'text-gray-700'}`}>
                  {row.month}
                </td>
                <td className="border border-gray-300 px-2 py-2 text-center">{row.sqls}</td>
                <td className="border border-gray-300 px-2 py-2 text-center">{row.sqos}</td>
                <td className="border border-gray-300 px-2 py-2 text-center">{row.closedWon}</td>
                <td className="border border-gray-300 px-2 py-2 text-center">{formatCurrency(row.monthlyArr)}</td>
                <td className="border border-gray-300 px-2 py-2 text-center">
                  {row.cumulativeArr > 0 ? formatCurrency(row.cumulativeArr) : '-'}
                </td>
                <td className="border border-gray-300 px-2 py-2 text-center">
                  {row.pipeline > 0 ? `$${row.pipeline.toFixed(1)}M` : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Summary Row */}
      <div className="mt-4 p-3 bg-blue-50 rounded border border-blue-200">
        <p className="text-xs font-semibold text-blue-900">
          Total Deals: {data.filter(r => r.month === '2026 Total')[0]?.closedWon || data.reduce((sum, row) => !row.isTotal ? sum + row.closedWon : sum, 0)} |
          Final ARR: {formatCurrency(data[data.length - 1]?.cumulativeArr || 0)} |
          Peak Pipeline: ${(Math.max(...data.filter(d => !d.isTotal).map(d => d.pipeline))).toFixed(1)}M
        </p>
      </div>
    </div>
  );
}

export default RevenueWaterfall;
